import React from 'react';
import { CardButton } from './CardButton';
import { NftButtonOptions } from './CardButtonContainer';
import { CardDropdownButton } from './CardDropdownButton';

export const CardButtonGroup: React.FC<{ buttons?: NftButtonOptions[] }> = (props) => {
  const buttons = [...(props.buttons ?? [])];
  const cta = buttons[0]?.cta;
  let maxButtonsDisplayed = cta ? 2 : 1;

  // Only display a single button and dropdown if there is more than 2 ctas
  if (cta && buttons.length > maxButtonsDisplayed) {
    maxButtonsDisplayed = 1;
  }

  if (buttons.length <= maxButtonsDisplayed) {
    return (
      <>
        {buttons.map((x, i) => (
          <CardButton key={i} {...x} />
        ))}
      </>
    );
  }

  const visibleButtons = buttons.slice(0, maxButtonsDisplayed);
  const dropDownButtons = buttons.slice(maxButtonsDisplayed);

  return (
    <>
      {visibleButtons.reverse().map((x, i) => (
        <CardButton key={i} {...x} />
      ))}
      <CardDropdownButton buttons={dropDownButtons} />
    </>
  );
};
